import React, { useState, useRef } from "react";
import formatTime from "helpers/formatTime";
import {
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
} from "mdbreact";
import numeral from "numeral";
import { useHistory, useLocation } from "react-router-dom";
import { eventTrack } from "helpers/ga4Helper";
import { useHttp } from "hooks/useHttp";
import addNotification from "helpers/notify";
import { adminEditProject } from "actions/admin";
import { editProjectPut } from "api/projects/updateProject";
import { useDispatch, useSelector } from "react-redux";
import { url } from "api";
import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { createFeatureRequest } from "api/featureRequests/createFeatureRequest";
import {
  setFeatureRequest,
  updateProjectData,
  setProjects,
} from "actions/user";
import { Modal } from "antd";
import { RequestCard } from "pages/configuration/requestCard";
import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import DefaultImage from "assets/images/user.png";
import { extractImageFromZip } from "helpers/extractImageFromZip";

import FULL_BATTERY_IMG from "assets/images/full.jpg";
import THREE_QUARTER_BATTERY_IMG from "assets/images/three-quarter.jpg";
import HALF_BATTERY_IMG from "assets/images/half.jpg";
import EMPTY_BATTERY_IMG from "assets/images/empty.jpg";
import { isModelUploading, isModelPartial, modelCoverageLabel } from "helpers/modelVisibility";

const COLUMNS = [
  { label: "Name", dataField: "title", dataType: "string" },
  { label: "", dataField: "favourite", dataType: "boolean" },
  { label: "Project No.", dataField: "projectNumber", dataType: "string" },
  { label: "Creation Date", dataField: "creationDate", dataType: "date" },
  { label: "3D Date", dataField: "date", dataType: "date" },
  { label: "Exported By", dataField: "exportedBy", dataType: "string" },
  { label: "Milestone", dataField: "milestone", dataType: "string" },
  { label: "Cost", dataField: "cost", dataType: "string" },
  { label: "Members", dataField: "n_users", dataType: "number" },
  { label: "Estimation Date", dataField: "estimationDate", dataType: "date" },
  { label: "Action", dataField: "action", dataType: "string" },
];

const Tabel = ({
  isAdmin,
  projectItem,
  milestones,
  usersObj,
  setModal,
  setProjectToDelete,
  setProjectToUpdate,
  setProjectListToEdit,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const FinalPermissions = allPermissionRedux
    ?.filter((element) => companyPermissionRedux?.includes(element))
    ?.filter((i) => usersPermissionRedux?.includes(i));
  const featureRequestRedux = useSelector((s) => s.user.featureRequest);
  const usersRedux = useSelector((s) => s.user.users);
  const projectsRedux = useSelector((s) => s.user.projects);
  const milestonesRedux = useSelector((s) => s.user.milestones);

  const [requestModal, setRequestModal] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);

  const {
    _id,
    title,
    favourite,
    date,
    milestone,
    timelines,
    users,
    isParent,
    parentProjectID,
    img,
    description,
    projectNumber,
  } = projectItem;

  // A column has to render something, so unlike the card surfaces this
  // one says so rather than going blank.
  const modelUploading = isModelUploading(projectItem);
  const modelPartial = isModelPartial(projectItem);
  const modelCoverage = modelCoverageLabel(projectItem);

  const exportedBy = projectItem?.zipInfo?.exportedBy?.name
    ? `${projectItem?.zipInfo?.exportedBy.name} ${projectItem?.zipInfo?.exportedBy.lastName}`
    : projectItem?.zipInfo?.exportedBy ?? "N/A";

  let n_users = users.slice(0, 4);

  const IconRef = useRef();
  const hiddenFileInput = useRef(null);
  const imageRef = useRef();
  const [requestType, setRequestType] = useState("");

  const projectItemState = useRef({ img, title, description, _id, favourite });

  const handleCameraClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleAccess = () => {
    setProjectListToEdit(projectItem);
    setModal("Share");
  };
  const handleMembers = () => {
    setProjectListToEdit(projectItem);
    setModal("ProjectListToEdit");
  };
  const handleHistory = () => {
    if (!isParent && parentProjectID != "") history.push(`../${_id}`);
    else history.push(`./personal-area/projects/${_id}/timelines`);

    {
      eventTrack(
        "View-History-Action",
        "View-History",
        title,
        _id,
        false,
        title
      );
    }
  };
  const handleDelete = () => {
    setProjectToDelete(projectItem);
    setModal("DeleteModal");
  };

  const { loading, request: editProjectAPI } = useHttp({
    requestCallback: editProjectPut,
    onLoad: (res) => {
      const cloneProjectArr = [...projectsRedux];
      const i = cloneProjectArr.findIndex((x) => x._id === res._id);
      cloneProjectArr[i] = { ...cloneProjectArr[i], favourite: res?.favourite };
      // dispatch(updateProjectData(res));
      dispatch(setProjects(cloneProjectArr));
      adminEditProject(res);
      addNotification("Project updated successfully", "success");
    },
    onError: (res) => {
      addNotification(res.message, "danger");
    },
  });

  const editProjectForm = new FormData();

  const editProjectField = (field) => {
    editProjectForm.append(field, projectItemState.current[field]);
  };

  const changeProject = (prop, payload) => {
    projectItemState.current = { ...projectItemState.current, [prop]: payload };
  };

  const editProject = () => {
    editProjectField("_id", _id);
    editProjectField("title", title);
    editProjectField("description", description);
    editProjectField("img", img);

    return editProjectAPI({
      id: projectItemState.current._id,
      body: editProjectForm,
    });
  };

  const toggleFavorite = (value) => {
    editProjectField("_id", _id);
    console.log("toggle favorite");
    // editProjectForm.append("favourite", !value);
    return editProjectAPI({
      _id: projectItemState.current._id,
      favourite: !value,
    });
  };

  const requestAccess = async () => {
    try {
      setRequestLoading(true);
      const res = await createFeatureRequest(userInfoRedux?.id, {
        companyId: userInfoRedux.company,
        permission: requestType,
        userId: userInfoRedux.id,
      });
      if (res) {
        setRequestLoading(false);
        dispatch(
          setFeatureRequest(res?.map((feature) => feature?.requestedFeature))
        );
      }
    } catch (e) {
      setRequestLoading(false);
    }
  };

  return (
    <>
      <tr key={_id}>
        {COLUMNS.map((column, index) => (
          <td key={index} className="f-14 poppins-regular capitalize">
            {column.dataField === "title" ? (
              title
            ) : column.dataField === "favourite" ? (
              <div
                onClick={() => toggleFavorite(favourite)}
                className="cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                >
                  <g clipPath="url(#clip0_426_6573)">
                    <rect
                      width="18"
                      height="18"
                      transform="translate(0.455078 0.45459)"
                      fill="white"
                    />
                    <path
                      d="M9.45602 14.1496L4.16593 17.1107L5.34743 11.1645L0.896484 7.04844L6.91676 6.33463L9.45602 0.82959L11.9952 6.33463L18.0155 7.04844L13.5646 11.1645L14.7461 17.1107L9.45602 14.1496Z"
                      fill={favourite ? "#FFBF1B" : "#ddd"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_426_6573">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0.455078 0.45459)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            ) : column.dataField === "projectNumber" ? (
              projectNumber ? (
                projectNumber
              ) : (
                "N/A"
              )
            ) : column.dataField === "creationDate" ? (
              formatTime(date)
            ) : column.dataField === "date" ? (
              modelUploading
                ? "Uploading…"
                : modelPartial
                  ? `Partial${modelCoverage ? ` — ${modelCoverage}` : ""}`
                  : formatTime(projectItem?.zipInfo?.date)
            ) : column.dataField === "exportedBy" ? (
              modelUploading ? "Uploading…" : exportedBy
            ) : column.dataField === "milestone" ? (
              <div className="d-flex align-items-center battery-container">
                {" "}
                {milestones && milestones[milestone]?.key}{" "}
                {Number(
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                ) == 0 ? (
                  <img
                    src={EMPTY_BATTERY_IMG}
                    alt="FULL_BATTERY_IMG"
                    title={`${
                      milestonesRedux?.find((item) => item?._id === milestone)
                        ?.value
                    }${"%"}`}
                    className="ml-auto mr-3"
                  />
                ) : Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) <= 25 &&
                  Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) > 0 ? (
                  <img
                    src={EMPTY_BATTERY_IMG}
                    alt="FULL_BATTERY_IMG"
                    title={`${
                      milestonesRedux?.find((item) => item?._id === milestone)
                        ?.value
                    }${"%"}`}
                    className="ml-auto mr-3"
                  />
                ) : Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) <= 50 &&
                  Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) >= 26 ? (
                  <img
                    src={HALF_BATTERY_IMG}
                    alt="FULL_BATTERY_IMG"
                    title={`${
                      milestonesRedux?.find((item) => item?._id === milestone)
                        ?.value
                    }${"%"}`}
                    className="ml-auto mr-3"
                  />
                ) : Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) <= 75 &&
                  Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) >= 51 ? (
                  <img
                    src={THREE_QUARTER_BATTERY_IMG}
                    alt="FULL_BATTERY_IMG"
                    title={`${
                      milestonesRedux?.find((item) => item?._id === milestone)
                        ?.value
                    }${"%"}`}
                    className="ml-auto mr-3"
                  />
                ) : Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) <= 100 &&
                  Number(
                    milestonesRedux?.find((item) => item?._id === milestone)
                      ?.value
                  ) >= 76 ? (
                  <img
                    src={FULL_BATTERY_IMG}
                    alt="FULL_BATTERY_IMG"
                    title={`${
                      milestonesRedux?.find((item) => item?._id === milestone)
                        ?.value
                    }${"%"}`}
                    className="ml-auto mr-3"
                  />
                ) : null}
              </div>
            ) : column.dataField === "cost" ? (
              <div className="d-flex">
                {timelines?.length ? (
                  <div className="number-count bg-light-warning text-warning px-2 health-result-status">
                    $
                    {numeral(
                      timelines[timelines.length - 1]?.estimation
                    ).format("0,0.00")}
                  </div>
                ) : (
                  <div className="number-count bg-light-bid text-bid px-2 health-result-status">
                    No Estimation
                  </div>
                )}
              </div>
            ) : column.dataField === "n_users" ? (
              <div className="users-profile-list">
                {n_users.map((val, index) => (
                  <img
                    key={index}
                    className="u-profile"
                    src={
                      usersObj &&
                      extractImageFromZip(usersObj[val]?.profilePhoto)
                    }
                    onError={(e) => (e.target.src = DefaultImage)}
                    alt={`User ${index + 1}`}
                    title={
                      usersObj &&
                      `${usersObj[val]?.name} ${usersObj[val]?.lastName}`
                    }
                  />
                ))}
                {users.length > 4 && (
                  <div className="u-profile">+{users.length - 1}</div>
                )}
              </div>
            ) : column.dataField === "estimationDate" ? (
              formatTime(date)
            ) : column.dataField == "action" ? (
              <MDBDropdown>
                <MDBDropdownToggle style={{ padding: 0 }} color="link">
                  <span className="cursor-pointer">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="5"
                      height="20"
                      viewBox="0 0 5 20"
                      fill="none"
                    >
                      <path
                        d="M2.73694 19.0519C2.43894 19.0563 2.14322 18.9996 1.86801 18.8853C1.59281 18.7709 1.34397 18.6013 1.13693 18.3869C0.922562 18.1799 0.752962 17.931 0.638581 17.6558C0.524199 17.3806 0.467459 17.0849 0.471924 16.7869C0.467459 16.4889 0.524199 16.1932 0.638581 15.918C0.752962 15.6428 0.922562 15.3939 1.13693 15.1869C1.34397 14.9725 1.59281 14.8029 1.86801 14.6885C2.14322 14.5742 2.43894 14.5174 2.73694 14.5219C3.03493 14.5174 3.33066 14.5742 3.60587 14.6885C3.88107 14.8029 4.1299 14.9725 4.33695 15.1869C4.55132 15.3939 4.72092 15.6428 4.8353 15.918C4.94968 16.1932 5.00642 16.4889 5.00195 16.7869C5.00642 17.0849 4.94968 17.3806 4.8353 17.6558C4.72092 17.931 4.55132 18.1799 4.33695 18.3869C4.1299 18.6013 3.88107 18.7709 3.60587 18.8853C3.33066 18.9996 3.03493 19.0563 2.73694 19.0519ZM2.73694 12.2619C2.43894 12.2664 2.14322 12.2097 1.86801 12.0953C1.59281 11.9809 1.34397 11.8113 1.13693 11.5969C0.922562 11.3899 0.752962 11.141 0.638581 10.8658C0.524199 10.5906 0.467459 10.2949 0.471924 9.99689C0.467459 9.69889 0.524199 9.40313 0.638581 9.12793C0.752962 8.85273 0.922562 8.60395 1.13693 8.39691C1.34397 8.18254 1.59281 8.01288 1.86801 7.8985C2.14322 7.78412 2.43894 7.72741 2.73694 7.73187C3.03493 7.72741 3.33066 7.78412 3.60587 7.8985C3.88107 8.01288 4.1299 8.18254 4.33695 8.39691C4.55132 8.60395 4.72092 8.85273 4.8353 9.12793C4.94968 9.40313 5.00642 9.69889 5.00195 9.99689C5.00642 10.2949 4.94968 10.5906 4.8353 10.8658C4.72092 11.141 4.55132 11.3899 4.33695 11.5969C4.12999 11.8115 3.8812 11.9813 3.60599 12.0958C3.33078 12.2104 3.03501 12.2662 2.73694 12.2619ZM2.73694 5.47192C2.43894 5.47639 2.14322 5.41968 1.86801 5.3053C1.59281 5.19092 1.34397 5.02126 1.13693 4.80689C0.922562 4.59984 0.752962 4.35107 0.638581 4.07587C0.524199 3.80066 0.467459 3.5049 0.471924 3.20691C0.467459 2.90892 0.524199 2.61316 0.638581 2.33795C0.752962 2.06275 0.922562 1.81391 1.13693 1.60687C1.34397 1.3925 1.59281 1.2229 1.86801 1.10852C2.14322 0.994139 2.43894 0.937429 2.73694 0.941895C3.03493 0.937429 3.33066 0.994139 3.60587 1.10852C3.88107 1.2229 4.1299 1.3925 4.33695 1.60687C4.55132 1.81391 4.72092 2.06275 4.8353 2.33795C4.94968 2.61316 5.00642 2.90892 5.00195 3.20691C5.00642 3.5049 4.94968 3.80066 4.8353 4.07587C4.72092 4.35107 4.55132 4.59984 4.33695 4.80689C4.12999 5.02144 3.8812 5.19123 3.60599 5.30579C3.33078 5.42034 3.03501 5.47626 2.73694 5.47192Z"
                        fill="#455E6C"
                      />
                    </svg>
                  </span>
                </MDBDropdownToggle>
                <MDBDropdownMenu
                  responsive="lg-end"
                  style={{ width: "200px" }}
                  className="border-none"
                >
                  <div className="card">
                    <div className="card-body p-2">
                      <div
                        onClick={() => {
                          if (
                            FinalPermissions?.includes(
                              ALL_PERMISSIONS.SHARE_PROJECT_ADD
                            )
                          ) {
                            handleAccess();
                          } else {
                            setRequestType(ALL_PERMISSIONS.SHARE_PROJECT_ADD);
                            setRequestModal(true);
                          }
                        }}
                        style={{
                          color: "white",
                          backgroundColor: "#3A5765",
                          marginBottom: "5px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        className="rounded p-1"
                      >
                        {" "}
                        Access{" "}
                      </div>
                      <div
                        onClick={() => {
                          if (
                            FinalPermissions?.includes(
                              ALL_PERMISSIONS.ASSIGN_PROJECT_ADD
                            )
                          ) {
                            handleMembers();
                          } else {
                            setRequestType(ALL_PERMISSIONS.ASSIGN_PROJECT_ADD);
                            setRequestModal(true);
                          }
                        }}
                        style={{
                          color: "white",
                          backgroundColor: "#3A5765",
                          marginBottom: "5px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        className="rounded p-1"
                      >
                        {" "}
                        Members{" "}
                      </div>
                      <div
                        onClick={() => {
                          if (
                            FinalPermissions?.includes(
                              ALL_PERMISSIONS.ESTIMATION_VIEW
                            )
                          ) {
                            handleHistory();
                          } else {
                            setRequestType(ALL_PERMISSIONS.ESTIMATION_VIEW);
                            setRequestModal(true);
                          }
                        }}
                        style={{
                          color: "white",
                          backgroundColor: "#3A5765",
                          marginBottom: "5px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        className="rounded p-1"
                      >
                        {" "}
                        History{" "}
                      </div>
                      <div
                        onClick={handleCameraClick}
                        style={{
                          marginBottom: "5px",
                          textAlign: "center",
                          border: "1px solid #3A5765",
                          cursor: "pointer",
                        }}
                        className="rounded p-1"
                      >
                        <MDBIcon
                          icon="camera"
                          size="lg"
                          style={{ color: "#3A5765" }}
                        />
                      </div>
                      <div
                        onClick={() => {
                          if (
                            FinalPermissions?.includes(
                              ALL_PERMISSIONS.PROJECT_DELETE
                            )
                          ) {
                            handleDelete();
                          } else {
                            setRequestType(ALL_PERMISSIONS.PROJECT_DELETE);
                            setRequestModal(true);
                          }
                        }}
                        style={{
                          marginBottom: "5px",
                          textAlign: "center",
                          border: "1px solid #3A5765",
                          cursor: "pointer",
                        }}
                        className="rounded p-1"
                      >
                        <MDBIcon
                          icon="trash-alt"
                          size="lg"
                          style={{ color: "#3A5765" }}
                        />
                      </div>
                    </div>
                  </div>
                </MDBDropdownMenu>
              </MDBDropdown>
            ) : null}
          </td>
        ))}
        <td style={{ display: "none" }}>
          <input
            type="file"
            name="file_image"
            className="file-input"
            id="input_image"
            required
            accept={".jpeg,.png,.jpg,.png"}
            // disabled={loading}
            ref={hiddenFileInput}
            onChange={(e) => {
              changeProject("img", e.target.files[0]);
              editProject();
            }}
          />
        </td>
      </tr>

      <Modal
        title={
          userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
        }
        open={requestModal}
        footer={null}
        onCancel={() => setRequestModal(false)}
      >
        <RequestCard
          status={featureRequestRedux?.includes(requestType)}
          loading={requestLoading}
          icon={
            featureRequestRedux?.includes(requestType) ? (
              <ClockCircleOutlined style={{ color: "black" }} />
            ) : (
              <InfoCircleOutlined style={{ color: "black" }} />
            )
          }
          title={
            featureRequestRedux?.includes(requestType)
              ? `Request Already Sent`
              : `Oops, looks like you need to ${
                  userInfoRedux?.companyAdmin
                    ? `Acquire License`
                    : `Request Access`
                }`
          }
          description={
            featureRequestRedux?.includes(requestType)
              ? `Please reach out to your project Admin`
              : `Elevate your experience with exclusive futures, early releases, and premium features.`
          }
          buttonText={
            userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
          }
          buttonHandler={() => requestAccess()}
        />
      </Modal>
    </>
  );
};

export default Tabel;
